import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Tooltip, TextField, Typography, InputAdornment } from "@material-ui/core";
import { Clear } from "@material-ui/icons";

import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";

import KPTable from "../../../components/KPTable";
import MonographUpdateModal from "../MonographUpdateModal";
import MonographDeleteModal from "../MonographDeleteModal";
import {
  WorkflowStatusChip,
  RevisionRequestLink,
  RevisionRequestDialog,
  STATUS_META,
  workflowMetaColumns,
  WorkflowFilterBar,
  ExportExcelButton,
  applyConditions,
} from "../../../components/WorkflowStatus";

import { updateMonograph, acceptMonograph, requestRevisionMonograph } from "../../../reducer/monograph/action";
import { statisticUnaccepted } from "../../../reducer/profile/action";
import { changePages } from "../../../reducer/home/action";
import MonographHistoryModal from "../MonographHistoryModal";

const deriveStatus = (row) => {
  if (row?.revisionStatus === "requested") return "revisionRequested";
  if (row?.revisionStatus === "resubmitted") return "resubmitted";
  if (row?.accepted) return "approved";
  return "pending";
};

function MonographTable(props) {
  const [editting, setEditting] = useState(null);
  const [updating, setUpdating] = useState(null);
  const [deleting, setDeleting] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [historyRow, setHistoryRow] = useState(null);
  const [revisionRow, setRevisionRow] = useState(null);
  const [revisionSubmitting, setRevisionSubmitting] = useState(false);
  const [advancedConditions, setAdvancedConditions] = useState([]);
  useEffect(() => {
    setAdvancedConditions([]);
  }, [props.type]);

  const handleUpdate = (e) => setUpdating(e);
  const handleEditYear = (e) => setEditting(e);

  const handleDelete = (event, e) => {
    setDeleting(e.id);
    setAnchorEl(event.currentTarget);
  };

  const handleChange = (value) => setEditting({ ...editting, dashboardYear: value });

  const handleSubmit = (e) => {
    e.preventDefault();
    props.updateMonograph(editting.id, editting);
    setEditting(null);
  };

  const handleClear = () => {
    props.updateMonograph(editting.id, { ...editting, dashboardYear: null });
    setEditting(null);
  };

  const acceptMonograph = async (e) => {
    let result = await props.acceptMonograph(e.id, !e.accepted);
    return result;
  };

  const handleAccept = (e) => {
    acceptMonograph(e).then((success) => {
      if (success) {
        props.statisticUnaccepted({ departmentId: 0, profileId: props.profile?.id });
        if (props.role === "sudo-admin") props.statisticUnaccepted({ departmentId: 0, profileId: 0 });
      }
    });
  };

  var list = [];
  if (props.type === "all") props.listMonograph.forEach((e) => list.push(e.monograph));
  else props.listMonographById.forEach((e) => list.push(e.monograph));

  const columns = [
    // {
    //   title: <b>ID</b>,
    //   key: 'id',
    //   width: '10%',
    //   sorter: (a, b) => a.id - b.id,
    // },
    {
      title: <b>Tác vụ</b>,
      key: "action",
      width: "20%",
      render: (value, row) =>
        row?.id !== editting?.id ? (
          <>
            <Typography
              className="table-action-buton"
              variant="caption"
              color="primary"
              onClick={() => handleUpdate(row)}
            >
              Chi tiết
            </Typography>
            <Typography
              className="table-action-buton"
              variant="caption"
              color="primary"
              onClick={() => setHistoryRow(row)}
            >
              Lịch sử
            </Typography>
            {row.locked ? (
              <Typography className="table-action-buton" variant="caption" color="textPrimary">
                {`Đã khóa ${
                  (row.locked === "kpi" && "KPI") ||
                  (row.locked === "reward" && "thưởng") ||
                  (row.locked === "timeResearch" && "giờ nghiên cứu")
                }`}
              </Typography>
            ) : (
              <>
                {(props.type !== "all" || props.role === "sudo-admin") && !row.accepted && (
                  <Typography
                    className="table-action-buton"
                    variant="caption"
                    color="secondary"
                    onClick={(event) => handleDelete(event, row)}
                  >
                    Xoá
                  </Typography>
                )}
                {props.role === "sudo-admin" && props.filter !== "workingPaper" && row.purposeId !== 4 && (
                  <>
                    <Typography
                      className="table-action-buton"
                      variant="caption"
                      color="primary"
                      onClick={(event) => handleAccept(row)}
                    >
                      {row.accepted ? "Hủy duyệt" : "Duyệt"}
                    </Typography>
                    <RevisionRequestLink row={row} onClick={setRevisionRow} />
                  </>
                )}
              </>
            )}
          </>
        ) : (
          <>
            <Typography className="table-action-buton" variant="caption" color="primary" onClick={handleSubmit}>
              Lưu
            </Typography>
            <Typography
              className="table-action-buton"
              variant="caption"
              color="secondary"
              onClick={() => setEditting(null)}
            >
              Huỷ
            </Typography>
          </>
        ),
    },
    {
      title: <b>Tên sách chuyên khảo</b>,
      key: "title",
      width: "30%",
      searchable: true,
      sorter: (a, b) => a.title.localeCompare(b.title),
    },
    {
      title: <b>Phân loại</b>,
      key: "timeResearchDetailCode",
      width: "20%",
      type: "include",
      filters: [
        {
          text: "Đề án chương trình đào tạo chuyên ngành",
          value: "38",
        },
        {
          text: "Giáo trình tái bản",
          value: "33",
        },
        {
          text: "Giáo trình xuất bản lần đầu",
          value: "32",
        },
        {
          text: "Sách chuyên khảo",
          value: "35",
        },
        {
          text: "Sách tham khảo",
          value: "34",
        },
        {
          text: "Sách xuất bản của NXB quốc tế có uy tín",
          value: "37",
        },
        {
          text: "Tài liệu hướng dẫn học tập cho sinh viên",
          value: "36",
        },
      ],
      onFilter: (value, row) => row.filter((e) => value.includes(e.type)),
      render: (value) => {
        if (value === "38") return "Đề án chương trình đào tạo chuyên ngành";
        if (value === "33") return "Giáo trình tái bản";
        if (value === "32") return "Giáo trình xuất bản lần đầu";
        if (value === "37") return "Sách xuất bản của NXB quốc tế có uy tín";
        if (value === "36") return "Tài liệu hướng dẫn học tập cho sinh viên";
        if (value === "35") return "Sách chuyên khảo";
        if (value === "34") return "Sách tham khảo";
        return "-";
      },
    },
    {
      title: <b>Năm xuất bản</b>,
      key: "year",
      width: "12%",
      sorter: (a, b) => a.year - b.year,
    },
    props.role === "sudo-admin" && props.type === "all"
      ? {
          title: <b>Năm hiển thị</b>,
          key: "dashboardYear",
          width: "12%",
          searchable: true,
          render: (value, row) =>
            row?.id !== editting?.id ? (
              <Tooltip title="Click để chỉnh sửa năm">
                <div style={{ cursor: "pointer" }} onClick={() => handleEditYear(row)}>
                  {value > 0 ? value : "Chưa có năm hiển thị"}
                </div>
              </Tooltip>
            ) : (
              <form onSubmit={handleSubmit}>
                <TextField
                  fullWidth
                  size="small"
                  type="tel"
                  variant="outlined"
                  value={editting?.dashboardYear || ""}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" style={{ cursor: "pointer" }} onClick={handleClear}>
                        <Clear style={{ fontSize: 18 }} />
                      </InputAdornment>
                    ),
                  }}
                  onChange={(e) => handleChange(parseInt(e.target.value))}
                />
              </form>
            ),
        }
      : {
          key: "dashboardYear",
          width: "0%",
          render: () => null,
        },
    {
      title: <b>Tình trạng</b>,
      key: "_status",
      width: "20%",
      render: (_, row) => <WorkflowStatusChip row={row} />,
      type: "include",
      filters: Object.entries(STATUS_META).map(([value, meta]) => ({ value, text: meta.label })),
      onFilter: (value, rows) => rows.filter((e) => value.includes(e._status)),
    },
    {
      title: <b>Mục đích</b>,
      key: "purposeId",
      width: "15%",
      type: "include",
      filters: props.purposes.map((e) => ({ value: e.id, text: e.description })),
      onFilter: (value, row) => row.filter((e) => value.includes(e.purposeId)),
      render: (value) => props.purposes.find((e) => e.id === value)?.description,
    },
    ...workflowMetaColumns({ width: "10%" }),
  ];

  if (props.volumnType === "all") columns.splice(2, 1);

  const enrichedRows = list.map((item) => ({ ...item, _status: deriveStatus(item) }));
  const filteredRows = applyConditions(enrichedRows, advancedConditions);
  const departmentName = (props.departments || []).find((d) => d.id === props.department)?.name;

  return (
    <>
      <div style={{ display: "flex", alignItems: "flex-start", gap: 8, marginBottom: 4 }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <WorkflowFilterBar
            conditions={advancedConditions}
            onChange={setAdvancedConditions}
            rows={enrichedRows}
          />
        </div>
        <ExportExcelButton rows={filteredRows} workType="monograph" />
      </div>
      <KPTable
        shadow="none"
        rowsPerPage={10}
        maxHeight="calc(100vh - 320px)"
        columns={columns}
        rows={filteredRows.slice(10 * props.workPages[3], 10 * (props.workPages[3] + 1))}
        totalData={list?.length}
        loading={props.isFetching}
        page={props.workPages[3]}
        onPageChange={(newPage) => props.changePages(3, newPage - 1)}
      />
      <MonographUpdateModal adminTab={props.adminTab} updating={updating} setUpdating={setUpdating} />
      <MonographDeleteModal deleting={deleting} anchorEl={anchorEl} setAnchorEl={setAnchorEl} />
      <MonographHistoryModal open={!!historyRow} row={historyRow} onClose={() => setHistoryRow(null)} />
      <RevisionRequestDialog
        row={revisionRow}
        submitting={revisionSubmitting}
        onClose={() => setRevisionRow(null)}
        onSubmit={async (reason) => {
          setRevisionSubmitting(true);
          const ok = await props.requestRevisionMonograph(revisionRow.id, reason);
          setRevisionSubmitting(false);
          if (ok) setRevisionRow(null);
        }}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  role: select(state, "userReducer", "role"),
  profile: select(state, "profileReducer", "detail"),
  workPages: select(state, "homeReducer", "workPages"),
  isFetching: select(state, "monographReducer", "isFetching"),
  listProject: select(state, "projectReducer", "list"),
  listMonograph: select(state, "monographReducer", "listFiltered"),
  listMonographById: select(state, "monographReducer", "listById"),
  purposes: select(state, "scientificResearchReducer", "purposes"),
  departments: select(state, "departmentReducer", "departments"),
});

const mapDispatchToProps = (dispatch) => ({
  acceptMonograph: (id, accept) => dispatch(acceptMonograph(id, accept)),
  requestRevisionMonograph: (id, reason) => dispatch(requestRevisionMonograph(id, reason)),
  statisticUnaccepted: (payload) => dispatch(statisticUnaccepted(payload)),
  updateMonograph: (id, payload) => dispatch(updateMonograph(id, payload)),
  changePages: (id, newPage) => dispatch(changePages(id, newPage)),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(MonographTable));

